module.exports = __webpack_public_path__ + "static/media/Zookeeper.e63c0ab1.jpg";